"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getServiceRating = void 0;
var getServiceRating = function (rating) { return (rating ? parseInt(rating.split('-')[1], 10) / 2 : 0); };
exports.getServiceRating = getServiceRating;
